import { LoaderService } from '@sd-portal/shared/shell';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {
  private readonly REFRESH_LOCK_NAME = 'sd-portal-token-refresh';

  constructor(
    private readonly oidcSecurityService: OidcSecurityService,
    private readonly loaderService: LoaderService,
  ) {}

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expirationTime = payload.exp * 1000; // Convert to milliseconds
      const currentTime = Date.now();

      // Consider token expired if it expires within next 60 seconds
      return expirationTime - currentTime < 60000;
    } catch {
      // If we can't parse the token, consider it not expired, let's handle it by 401 error
      return false;
    }
  }

  async refreshToken(): Promise<void> {
    const currentToken = await this.oidcSecurityService.getAccessToken().pipe(take(1)).toPromise();

    if (currentToken && !this.isTokenExpired(currentToken)) {
      // Token is still valid, no need to refresh
      return;
    }

    try {
      await navigator.locks.request(this.REFRESH_LOCK_NAME, async () => {
        this.loaderService.showGlobalLoader();

        await this.oidcSecurityService.forceRefreshSession().pipe(take(1)).toPromise();
        const token = await this.oidcSecurityService.getAccessToken().pipe(take(1)).toPromise();
        window.sdPortalAuthToken = token;
      });
    } catch {
    } finally {
      this.loaderService.hideGlobalLoader();
    }
  }
}
